import React, { useState, useEffect } from "react";
import { useHistory, useLocation, useParams } from "react-router-dom";
import API from "../../../Services/BaseService";
import CommonPopup from "../../../Component/CommonPopup/CommonPopup";
import { useDispatch, useSelector } from "react-redux";
import ls from "local-storage";
import StateAndCity from "../../../Component/StateAndCity/StateAndCity";
import Datetime from 'react-datetime';
import moment from 'moment';
import 'react-datetime/css/react-datetime.css';
// import EditPopup from '../MailLog/MailLogEdit/EditPopup';
import ViewPopup from '../BillOfSales/ViewPopup';
import Popup from "../../../Component/Popup/Popup";
import { Button } from "antd";
import Loading from "../../../Component/Loading/Loading";

const ViewMailLog = (props) => {
  const history = useHistory();
  const [loading, setloading] = useState(true);
  // const { mailLogId } = props.location.state;
  const maillogid = ls.get("maillogid")
  const yesterday = moment().subtract(1, 'day');
  const disablePastDt = current => {
    return current.isAfter(yesterday);
  };
  const [customerType, setCustomerType] = useState("");
  const [customerId, setCustomerId] = useState("");
  const [customerName, setCustomerName] = useState("");
  const [bosId, setBosId] = useState("");
  const [invId, setInvId] = useState("");
  const [address, setAddress] = useState("");
  const [organization, setOrganization] = useState("");
  const [country, setCountry] = useState("");
  const [stateName, setStateName] = useState("");
  const [cityName, setCityName] = useState("");
  const [zipcode, setZipcode] = useState("");
  const [trackingId, setTrackingId] = useState("");
  const [checkId, setCheckId] = useState("");
  const [sendToName, setSendToName] = useState("");
  const [sendToId, setSendToId] = useState("");
  const [itemSent, setItemSent] = useState("");

  const [dateSent, setDateSent] = useState("");
  const [otherSent, setOtherSent] = useState("");
  const [sentby, setSentBy] = useState("");
  const [tracking, setTracking] = useState("");
  const [check, setCheck] = useState("");
  const [sendToList, setSendToList] = useState("");

  const [bankList, setBankList] = useState("");
  const [bankId, setBankId] = useState("");
  const [selectedBankId, setSelectedBankId] = useState("");

  const [sentViaList, setSentViaList] = useState("");
  const [sentViaId, setSentViaId] = useState("");
  const [selectedsentViaId, setSelectedSentViaId] = useState("");
  const [mailLogList, setMailLogList] = useState("");

  //---------------Error Part--------------------------------//

  const [customerError, setCustomerError] = useState("");
  const [nameError, setNameError] = useState("");
  const [bosIdError, setBosIdError] = useState("");
  const [invIdError, setInvIdError] = useState("");
  const [addressError, setAddressError] = useState("");
  const [organisationError, setOrganizationError] = useState("");
  const [countryError, setCountryError] = useState("");
  const [stateError, setStateError] = useState("");
  const [cityError, setCityError] = useState("");
  const [zipcodeError, setZipcodeError] = useState("");
  const [dateSentError, setDateSentError] = useState("");

  const [itemSentError, setItemSentError] = useState("");
  const [itemSentOtherError, setItemSentOtherError] = useState("");
  const [bankError, setBankError] = useState("");
  const [trackingError, setTrackingError] = useState("");
  const [checkError, setCheckError] = useState("");
  const [sentViaIdError, setSentViaIdError] = useState("");
  const [sendToNameError, setSendToNameError] = useState("");
  const [sendToIdError, setSendToIdError] = useState("");

  const [popupTitle, setPopupTitle] = useState("");
  const [popupMsg, setPopupMsg] = useState("");
  const [popupType, setPopupType] = useState("");
  const [popupActionType, setPopupActionType] = useState("");
  const [popupActionValue, setPopupActionValue] = useState("");
  const [popupActionPath, setPopupActionPath] = useState("");
  const [isOpen, setIsOpen] = useState(false);

  const [isEdit, setIsEdit] = useState(false);
  const [isView, setIsView] = useState(false);
  const [mailLogDetailsId, setMailLogDetailsId] = useState("");

  const toggleMailEditPopup = (item) => {
    setIsEdit(!isEdit);
    setMailLogDetailsId(item.maillog_details_id);
    console.log("charges_id", item.maillog_details_id)
  }
  const toggleMailViewPopup = (item) => {
    setIsView(!isView);
    setMailLogDetailsId(item.maillog_details_id);
    console.log("charges_id", item.maillog_details_id)
  }
  const togglePopup = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    mailBankAccount();
    mailSentItem();
    getCustomerDetails();
    getSendToDetails();
  }, []);
  const reCallFunction = () => {
    getSendToDetails();

  }
  const getCustomerDetails = () => {
    let request = {
      maillog_id: maillogid
    }
    API.post("maillogviewbyid/condition", request).then((response) => {
      console.log("mailBankAccount", response.data.data[0]);
      setMailLogList(response.data.data[0]);
      setloading(false);

    });
  };
  const getSendToDetails = () => {
    let request = {
      maillog_id: maillogid
    }
    API.post("maillogdetailslist/condition", request).then((response) => {
      console.log("mailBankAccount", response.data.data[0]);
      setSendToList(response.data.data);
    });
  };
  const mailBankAccount = () => {
    API.post("bankaccount/condition").then((response) => {
      console.log("mailBankAccount", response.data.data);
      setBankList(response.data.data);
    });
  };

  const mailSentItem = () => {
    API.post("maillogsentitem/condition").then((response) => {
      console.log("mailSentItem", response.data.data);
      setSentViaList(response.data.data);
    });
  };



  const getStateName = (stateData) => {
    setStateName(stateData);
    setCityName(null);
    setZipcode(null);
  };

  const getCityName = (cityData) => {
    setCityName(cityData);
    setZipcode(null);
  };

  const getZipCodeId = (zipData) => {
    setZipcode(zipData);
  };

  const handleBankAccount = (e) => {
    setBankId(e.target.value);
    console.log("=========check", e.target.value);
    setSelectedBankId(bankList.filter((data) => data.bank_account_id == e.target.value)[0]);
    console.log("=========check", bankList.filter((data) => data.bank_account_id == e.target.value)[0]);
  };

  const handleSentVia = (e) => {
    setSentViaId(e.target.value);
    console.log("=========check", e.target.value);
    setSelectedSentViaId(sentViaList.filter((data) => data.maillog_sent_item_id == e.target.value)[0]);
    console.log("=========check", sentViaList.filter((data) => data.maillog_sent_item_id == e.target.value)[0]);
  };

  const inputProps = {
    placeholder: "YYYY/MM/DD",
    // value : expiration
  };

  const getDate = (event) => {
    setDateSent(event.format("YYYY/MM/DD"))
  }
  const redirectionCar = (carId) => {
    history.push("/viewvehicleinfo");
    ls.set("carId", carId);
  };
  const redirectionDealer = (data) => {
    if (data?.type == "buyer") {
      history.push("/ViewBuyer");
      ls.set("buyerDealerId", data?.sent_to);
    }
    else {
      history.push("/sellerviewinfo");
      ls.set("sellerDealerId", data?.sent_to);
    }
  };
  return (
    <main id="main" className="inner-page">

      <div class="container-fluid inner-page-space ">

        {loading ? <Loading /> :
          <div>
            <div class="back-btn">
              <a class="back-btn-primary" onClick={() => history.goBack()}>
                <i class="bx bx-chevron-left"></i> Back
              </a>
            </div>
            <div class="section-title pb-0">
              <h2>View Mail Log</h2>
            </div>

            <div class="viewmaillog">
              <form>
                <div class="custom-card">
                  <div class="">
                    <div class="d-flex mb-4 mt-4">
                      <div class="me-auto">
                        <h5 class="text-color">Default Information</h5>
                      </div>
                    </div>
                    <div class="row">

                      <div class="col-md-6 col-lg-4  form-group">
                        <div class="tbox">
                          <input type="text" class="textbox" placeholder="" id="customerType" disabled value={mailLogList?.type} />
                          <label for="customerType" class="input-has-value" >Customer Type</label>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4  form-group">
                        <div class="tbox">
                          <input type="text" class="textbox" placeholder="" id="customerType" disabled value={mailLogList?.sent_to} />
                          <label for="customerType" class="input-has-value" >Customer #</label>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4  form-group">
                        <div class="tbox">
                          <input type="text" class="textbox" placeholder="" id="customerType" disabled value={mailLogList?.sent_to_name} />
                          <label for="customerType" class="input-has-value" >Customer Name</label>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4  form-group">
                        <div class="tbox">
                          <input type="text" class="textbox" placeholder="" id="customerType" disabled value={mailLogList?.bill_of_sale_id} />
                          <label for="customerType" class="input-has-value" >BillOfSale #</label>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4  form-group">
                        <div class="tbox">
                          <input type="text" class="textbox" placeholder="" id="customerType" disabled value={mailLogList?.car_id} />
                          <label for="customerType" class="input-has-value" >Inventory #</label>
                        </div>
                      </div>

                      <div class="col-md-6 col-lg-4  form-group">
                        <div class="tbox">
                          <input type="text" class="textbox" placeholder="" id="customerType" disabled value={mailLogList?.sent_to_organisation} />
                          <label for="customerType" class="input-has-value" >Organization</label>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4 mt-4">
                      <div class="me-auto">
                        <h5 class="text-color">Mail Log Details</h5>
                      </div>
                    </div>

                    <div class="userlisttable table-responsive">
                      <table className="table">
                        <thead>
                          <tr>
                            <th class="th_id">Mail Log Details #</th>
                            <th class="th_id">Sent By</th>
                            <th class="th_id">Item Send </th>
                            <th class="th_id">Sent Date</th>
                            <th class="th_id">Sent Via</th>
                            <th class="th_id">Tracking #</th>
                            <th class="th_id">Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {sendToList.length > 0 ? sendToList.map((sendToList) =>
                            <tr>
                              <td>{sendToList.maillog_details_id}</td>
                              <td>{sendToList.sent_name}</td>
                              <td>{sendToList.item_sent == "other" ? sendToList.item_sent_others : sendToList.item_sent}</td>
                              <td>{sendToList.date_sent}</td>
                              <td>{sendToList.maillog_sent_item}</td>
                              <td>{sendToList.tracking}</td>
                              <td class="action">
                                <Button
                                  className="ant-btn"
                                  onClick={() => toggleMailViewPopup(sendToList)}
                                >
                                  View
                                </Button>
                              </td>
                            </tr>
                          ) : <tr>
                            <td colspan="20" className="text-center">
                              <p>No Data Found</p>
                            </td>
                          </tr>}

                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>
                <div>
                </div>
              </form>
            </div>

            {isOpen && (
              <CommonPopup
                handleClose={togglePopup}
                popupTitle={popupTitle}
                popupMsg={popupMsg}
                popupType={popupType}
                popupActionType={popupActionType}
                popupActionValue={popupActionValue}
                popupActionPath={popupActionPath}
              />
            )}
            {/* {isEdit && <Popup
            isClose={false}
            content={<>
                <EditPopup toggle={toggleMailEditPopup} mailLogDetailsId={mailLogDetailsId} reCallFunction={reCallFunction}/>
            </>}
            handleClose={toggleMailEditPopup}
        />} */}
            {isView && <Popup
              isClose={false}
              content={<>
                <ViewPopup toggle={toggleMailViewPopup} mailLogDetailsId={mailLogDetailsId} />
              </>}
              handleClose={toggleMailViewPopup}
            />}
          </div>}
      </div>
    </main>
  );
};

export default ViewMailLog;
